<div class="flex"  [class]="storeField?.LabelPosition == PositionType.Left? 'flex-row flex-wrap': 'flex-col' " [class.items-center]="storeField?.ComponentType !== TableFieldDataType.Memo && storeField?.LabelPosition == PositionType.Left" tabIndex="-1"
     [hidden]="storeField?.IsHidden">
    @if (displayCaption && !isGridControl && !storeField?.IsHidden) {
        <label class="flex gap-1 text-sm font-semibold" [class.w-max]="storeField?.LabelPosition == PositionType.Left" [for]="storeField?.Id">
            <span class="flex" [class.w-max]="storeField?.LabelPosition == PositionType.Left" [class]="storeField?.ComponentType == TableFieldDataType.Memo && storeField?.LabelPosition == PositionType.Left ? 'items-start' : 'items-center'" [innerHTML]="storeField?.Caption"></span>
            @if (storeField?.IsRequired) {
                <span class="-top-0.5 h-5 text-xl leading-4 text-red-400">*</span>
            }
            @if (errorState?.Message; as errorMessage) {
                <bizz-tooltip
                        class="relative -top-2 inline-flex h-5 cursor-pointer text-xl leading-4 text-red-400"
                        [text]="errorMessage"></bizz-tooltip>
            }
            @if (storeField && storeField.Hint) {
                <bizz-tooltip class="ml-1" [text]="storeField.Hint"></bizz-tooltip>
            }
        </label>
    }
    <div class="flex"  [class]="storeField?.LabelPosition == PositionType.Left ? 'ml-1' : 'min-w-full'" [class.min-w-full]="storeField?.ComponentType == TableFieldDataType.None"  tabIndex="-1">
        <ng-container viewContainerRef>
        </ng-container>
    </div>
</div>
